<div class="wrapper-md">
    <app-breadcrumbs [items]="[{ url: '/midterm-exam-payments', text: 'midtermExamPayment_listTitle' }]"></app-breadcrumbs>

    <header class="content-header">
        <h1>{{'midtermExamPayment_listTitle' | translate}}</h1>
        <aside>
            <button type="button" class="btn btn-outline-primary" [routerLink]="['/midterm-exam-payments/add'] | localize">
                <i class="fi fi-rs-plus"></i>
                {{'add' | translate}}
            </button>
        </aside>
    </header>

    <div class="row">
        <div class="col-lg form-field">
            <app-select name="filterCourse"
                        [placeholder]="'midtermExamPayment_lblCourse' | translate"
                        [options]="filters.course.options"
                        [displayProperty]="'name'"
                        [valueProperty]="'id'"
                        [multiple]="true"
                        [(ngModel)]="filters.course.value"
                        (selectionChange)="filter()">
            </app-select>
        </div>

        <div class="col-lg form-field">
            <app-select name="filterSemester"
                        [placeholder]="'midtermExamPayment_lblSemester' | translate"
                        [options]="filters.semester.options"
                        [multiple]="true"
                        [(ngModel)]="filters.semester.value"
                        (selectionChange)="filter()">
            </app-select>
        </div>

        <div class="col-lg form-field">
            <input class="form-control"
                    name="filterText"
                    [placeholder]="'midtermExamPayment_lblSearch' | translate"
                    [(ngModel)]="filters.text"
                    (input)="filter()">
        </div>
    </div>

    <app-table [rows]="items" [columns]="columns">
        <ng-template #rowTemplate let-row>
            <tr>
                <td class="hidden-md-up">
                    <div class="text-top">{{row.CourseCode}} - {{row.CourseName}}</div>
                    <div>{{row.StudentFullName}}</div>
                    <div class="text-sub">{{row.Created | appDate:'datetime'}}</div>
                    <div class="mt-1">
                        <app-midterm-exam-payment-status [value]="row?.Status"></app-midterm-exam-payment-status>
                    </div>
                </td>
                <td class="hidden-sm-down">
                    <div>{{row.CourseCode}} - {{row.CourseName}}</div>
                    <div class="text-sub">{{row.Semester}}</div>
                </td>
                <td class="hidden-sm-down">
                    <div>{{row.StudentFullName}}</div>
                    <div class="text-sub">{{row.StudentUpn}}</div>
                </td>
                <td class="hidden-sm-down">
                    <div>{{row.Created | appDate:'datetime'}}</div>
                    <div class="text-sub">&mdash; {{row.Amount | number:'1.2-2':'en-US'}} EUR</div>
                </td>
                <td class="hidden-sm-down">
                    <app-midterm-exam-payment-status [value]="row?.Status"></app-midterm-exam-payment-status>
                </td>
                <td>
                    <div class="table-actions">
                        <button type="button" class="btn btn-outline btn-icon" (click)="open(row)"
                                [ngbTooltip]="'open' | translate">
                            <i class="fi fi-rs-angle-right"></i>
                        </button>
                    </div>
                </td>
            </tr>
        </ng-template>
    </app-table>
</div>
